import React from 'react';
import landingRightImg from '../images/nemwelLanding.png';

const Landing = () => (
  <div className="Landing">
    <div className="landingLeft">
      <div className="landingHeader">
        <h4>
          Hello
          <span> i&apos;m</span>
        </h4>
        <h2>Nemwel Boniface</h2>
        <h4>Software developer</h4>
      </div>
      <p className="nemwelDesc">
        I can help you build a product , feature or website Look through
        some of my work and experience! If you like what you see and have a
        project you need coded, don&apos;t hestiate to contact me.
      </p>
      <div className="landingSocials">
        <p>FIND ME ON</p>
        <ul>
          <li>
            <a href="https://www.linkedin.com/in/nemwel-nyandoro" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-linkedin" aria-hidden="true" />
              {' '}
            </a>
          </li>
          <li>
            <a href="https://github.com/Nemwel-Boniface" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-github" aria-hidden="true" />
              {' '}
            </a>
          </li>
          <li>
            <a href="https://angel.co/u/nemwel-nyandoro" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-angellist" aria-hidden="true" />
              {' '}
            </a>
          </li>
          <li>
            <a href="https://twitter.com/nemwel_bonie" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-twitter" aria-hidden="true" />
              {' '}
            </a>
          </li>
        </ul>
      </div>
      <div className="yrProjClients">
        <div className="landingmoreInfo">
          <h3>3+</h3>
          <p>Years of experience</p>
        </div>
        <div className="landingmoreInfo">
          <h3>40+</h3>
          <p>Completed projects</p>
        </div>
        <div className="landingmoreInfo">
          <h3>50+</h3>
          <p>Happy clients</p>
        </div>
      </div>
    </div>
    <div className="landingRight">
      <img src={landingRightImg} alt="Nemwel Boniface portrait" />
    </div>
  </div>
);

export default Landing;
